module.exports = __webpack_public_path__ + "img/detail-solution-1-4.66d02d29.png";